import {IntermediatePart} from "../../intermediatePart";

export default class BathTubFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_fixture";
    this.partName = "Fixture";
    this.translateId = "visualizer.bathroom.bathtub.bathtub_fixture";
    this.dbName = "Bathtub Fixture";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubFixture());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Bathtub.BathTubFixture;
    }
  }
}
